<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>区域设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">区域设置</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd()">
          <span>添加区域设置</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <div class="custom-wrap">
        <template v-if="list && list.length">
          <Table :border="false" :columns="columns1" :data="list" row-key="id" :disabled-hover="false">
            <template slot-scope="{ row, index }" slot="name">
              <span class="brand">{{row.name}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="nameEn">
              <span class="brand">{{row.nameEn}}</span>
            </template>
            <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
            <template slot-scope="{ row, index }" slot="action">
              <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
              <span style="display: inline-block;padding: 0 5px;">|</span>
              <span
                style="color: #1890ff;cursor: pointer;"
                @click="editSubShow(row)"
                v-if="row.type === 1"
              >添加子项</span>
              <span
                style="display: inline-block;padding: 0 5px;"
                v-if="row.type === 1"
              >|</span>
              <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
                <span style="color: #f00;cursor: pointer;">删除</span>
              </Poptip>
            </template>
          </Table>
        </template>
        <div class="u-empty" v-else>暂无数据</div>
      </div>
      <regionAdd
        :show="show"
        @finish="init()"
        @close="show=false;"
        :options="options"
        :modelTitle="modelTitle"
      />
      <regionAddChild
        :show="showChild"
        @finish="init()"
        @close="showChild=false;"
        :options="optionsChild"
        :modelTitle="modelTitle"
      />
    </div>

  </div>
</template>

<script>
import regionAdd from "../components/region-add.vue";
import regionAddChild from "../components/region-child-add.vue";
import { mapActions } from "vuex";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null, 
      edit: false,
      editInfo: false,
      show: false, 
      options:{}, 
      modelTitle:'',
      columns1: [
        {
          title: "中文名称",
          key: "name",
          tree: true,
        },
        {
          title: "英文名称",
          slot: "nameEn",
          key: "nameEn",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      showChild: false,
      optionsChild:{},
      showRecord: [], // 记录表格点开的行
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    regionAdd,
    regionAddChild,
  },
  watch: {
    list: {
      handler:function(val) {
        val.map(c => {
          // 添加
          if (c._showChildren && this.showRecord.indexOf(c.id) === -1) {
            this.showRecord.push(c.id);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (d._showChildren && this.showRecord.indexOf(d.id) === -1) {
                this.showRecord.push(d.id);
              }
            })
          }
          // 移除
          if (!c._showChildren && this.showRecord.indexOf(c.id) !== -1) {
            let num = this.showRecord.indexOf(c.id);
            this.showRecord.splice(num,1);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (!d._showChildren && this.showRecord.indexOf(d.id) !== -1) {
                let num2 = this.showRecord.indexOf(d.id);
                this.showRecord.splice(num2,1);
              }
            })
          }
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      getRegion:'hostSetModule/getRegion',
      delRegion:'hostSetModule/delRegion',
    }),  
    async init() {
      let listData = await this.getRegion();
      if (listData && listData.length > 0) {
        listData.map(c => {
          c.children = c.list;
          c.type = 1;
          // 若存在，展开对应的行
          if (this.showRecord && this.showRecord.indexOf(c.id) !== -1) {
            c._showChildren = true;
          } else {
            c._showChildren = false;
          }

          c.children.map(d => {
            d.type = 1;
            d.children = d.list;
            // 若存在，展开对应的行
            if (this.showRecord && this.showRecord.indexOf(d.id) !== -1) {
              d._showChildren = true;
            } else {
              d._showChildren = false;
            }
          })
        })
        this.list = listData;
      }
    }, 
    async delItem(item) { 
      let result = await this.delRegion(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    },
    editSubShow(item) {
      this.showChild = true;
      this.modelTitle = '新增子项目';
      this.optionsChild = {
        model:'edit',
        msg:item,
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.common-ad {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 35px 18px 35px;
    background: #fff;
    &-text {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
    &-box {
      flex: 1;
      text-align: right;
    }
  }
  .custom-wrap {
    margin: 0 auto;
    min-height: 500px;
  } 
}
</style>